<!-- Standard Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{ modalTitle }}</h3>
  <div class="header-actions">
    <i class="fa"
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;"
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- Modal Body -->
<div class="modal-body no-body-scroll" [hidden]="minimise">
  @if (showFormLoader) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
  </div>
}
  @if (!showFormLoader) {
<div>
    <i class="fa fa-exclamation-circle" aria-hidden="true"></i>&nbsp;<em>If the prior year ending balance is not equal to the current year beginning balance US tax law requires a reconciliation of the difference, please provide a detailed explanation of the difference in the area provided.</em>
    <div>
      <br>
      <table class="table table-bordered custom-table" style="margin-bottom: 0px;">
        <thead>
          <tr>
            <th width="30%">Account Code</th>
            <th width="30%">Account Description</th>
            <th width="40%">Amount per Trial Balance</th>
          </tr>
        </thead>
      </table>
      <table class="table table-bordered custom-table" style="margin-bottom: 0px;">
        <tbody>
          <tr>
            <td width="60%">
              @if (cyopen !== true) {
<i (click)="showDetailsCY(0, true)" style="font-size:20px" class="fa fa-plus-circle"></i>
}
              @if (cyopen) {
<i (click)="showDetailsCY(0, false)" style="font-size:20px" class="fa fa-minus-circle"></i>
}
              Opening Retained Earnings per {{ rowData.CY_TAX_YEAR }} Trial Balance
            </td>
            <td width="40%" style="text-align: right;">{{ formatNumber(rowData.CY_RE_AMT) }}</td>
          </tr>
        </tbody>
      </table>
      <table class="table table-bordered custom-table">
        <tbody>
          @if (cyopen) {

            @for (t of cy_local_acct_dtls; track $index) {
<tr>
              <td width="30%">{{ t.LOCAL_ACCT }}</td>
              <td width="30%">{{ t.LOCAL_ACCT_DESC }}</td>
              <td width="60%" style="text-align: right;">{{ formatNumber(t.AMT) }}</td>
            </tr>
}
          
}
        </tbody>
      </table>
      <table class="table table-bordered custom-table">
        <tbody>
          <tr>
            <td width="60%">{{ rowData.CY_TAX_YEAR }} Current year December 11/30 Reclass Adjustments</td>
            <td width="40%" style="text-align: right;">{{ formatNumber(rowData.CY_11_30_CURR_AMT) }}</td>
          </tr>
          <tr>
            <td width="60%">{{ rowData.CY_TAX_YEAR }} Prior year December 11/30 Reclass Adjustments</td>
            <td width="40%" style="text-align: right;">{{ formatNumber(rowData.CY_11_30_PRIOR_AMT) }}</td>
          </tr>
          <tr>
            <td width="60%">Other Reclass Adjustments Posted to {{ rowData.CY_TAX_YEAR }} Opening Retained Earnings</td>
            <td width="40%" style="text-align: right;">{{ formatNumber(rowData.CY_S_AMT) }}</td>
          </tr>
          <tr>
            <td width="60%"><b>{{ rowData.CY_TAX_YEAR }} Opening Balance in Retained Earnings</b></td>
            <td width="40%" style="text-align: right;"><b>{{ formatNumber(rowData.CY_AMT_PER_TB) }}</b></td>
          </tr>
        </tbody>
      </table>
      <table class="table table-bordered custom-table" style="margin-bottom: 0px;">
        <thead>
          <tr>
            <th width="30%">Account Code</th>
            <th width="30%">Account Description</th>
            <th width="40%">Amount per Trial Balance</th>
          </tr>
        </thead>
      </table>
      <table class="table table-bordered custom-table" style="margin-bottom: 0px;">
        <tbody>
          <tr>
            <td width="60%">
              @if (pyopen !== true) {
<i (click)="showDetailsPY(0, true)" style="font-size:20px" class="fa fa-plus-circle"></i>
}
              @if (pyopen) {
<i (click)="showDetailsPY(0, false)" style="font-size:20px" class="fa fa-minus-circle"></i>
}
              Opening Retained Earnings per {{ rowData.PY_TAX_YEAR }} Trial Balance
            </td>
            <td width="40%" style="text-align: right;">{{ formatNumber(rowData.PY_RE_AMT) }}</td>
          </tr>
        </tbody>
      </table>
      <table class="table table-bordered custom-table" style="margin-bottom: 0px;">
        <tbody>
          @if (pyopen) {

            @for (t of py_local_acct_dtls; track $index) {
<tr>
              <td width="30%">{{ t.LOCAL_ACCT }}</td>
              <td width="30%">{{ t.LOCAL_ACCT_DESC }}</td>
              <td width="60%" style="text-align: right;">{{ formatNumber(t.AMT) }}</td>
            </tr>
}
          
}
        </tbody>
      </table>
      <table class="table table-bordered custom-table">
        <tbody>
          <tr>
            <td width="60%">GAAP Net Income per {{ rowData.PY_TAX_YEAR }} Trial Balance</td>
            <td width="40%" style="text-align: right;">{{ formatNumber(rowData.PY_GAAP_AMT) }}</td>
          </tr>
          <tr>
            <td width="60%">Other Reclass Adjustments Posted to {{ rowData.PY_TAX_YEAR }} Opening Retained Earnings</td>
            <td width="40%" style="text-align: right;">{{ formatNumber(rowData.PY_S_AMT) }}</td>
          </tr>
          <tr>
            <td width="60%">{{ rowData.CY_TAX_YEAR }} Current year December 11/30 Reclass Adjustments posted to {{ rowData.PY_TAX_YEAR }} Opening Retained Earnings</td>
            <td width="40%" style="text-align: right;">{{ formatNumber(rowData.PY_11_30_CURR_AMT) }}</td>
          </tr>
          <tr>
            <td width="60%">{{ rowData.PY_TAX_YEAR }} Prior year December 11/30 Reclass Adjustments posted to {{ rowData.PY_TAX_YEAR }} Opening Retained Earnings</td>
            <td width="40%" style="text-align: right;">{{ formatNumber(rowData.PY_11_30_PRIOR_AMT) }}</td>
          </tr>
          <tr>
            <td width="60%">Other Reclass Adjustments Posted to {{ rowData.PY_TAX_YEAR }} GAAP Net Income</td>
            <td width="40%" style="text-align: right;">{{ formatNumber(rowData.PY_S_AMT_FOR_GAAP) }}</td>
          </tr>
          <tr>
            <td width="60%">{{ rowData.PY_TAX_YEAR }} Current year December 11/30 Reclass Adjustments posted to {{ rowData.PY_TAX_YEAR }} GAAP Net Income</td>
            <td width="40%" style="text-align: right;">{{ formatNumber(rowData.PY_11_30_CURR_AMT_FOR_GAAP) }}</td>
          </tr>
          <tr>
            <td width="60%">{{ rowData.PY_TAX_YEAR }} Prior year December 11/30 Reclass Adjustments posted to {{ rowData.PY_TAX_YEAR }} GAAP Net Income</td>
            <td width="40%" style="text-align: right;">{{ formatNumber(rowData.PY_11_30_PRIOR_AMT_FOR_GAAP) }}</td>
          </tr>
          <tr>
            <td width="60%">Adjustments posted to {{ rowData.PY_TAX_YEAR }} opening balance</td>
            <td width="40%" style="text-align: right;">{{ formatNumber(rowData.PY_ENDING_AMT_ADJS) }}</td>
          </tr>
          <tr>
            <td width="60%">{{ rowData.PY_TAX_YEAR }} Dividends Declared</td>
            <td width="40%" style="text-align: right;">{{ formatNumber(rowData.PY_DIV_AMT) }}</td>
          </tr>
          <tr>
            <td width="60%">{{ rowData.PY_TAX_YEAR }} Other non-dividends</td>
            <td width="40%" style="text-align: right;">{{ formatNumber(rowData.PY_OTHER_DIV_AMT) }}</td>
          </tr>
        </tbody>
      </table>
      <table class="table table-bordered custom-table">
        <tbody>
          <tr>
            <td width="60%"><b>{{ rowData.PY_TAX_YEAR }} Ending Balance in Retained Earnings</b></td>
            <td width="40%" style="text-align: right;"><b>{{ formatNumber(rowData.PY_ENDING_AMT) }}</b></td>
          </tr>
        </tbody>
      </table>
      <table class="table table-bordered custom-table">
        <tbody>
          <tr>
            <td width="60%"><b>Reconciling Item</b></td>
            <td width="40%" style="text-align: right;"><b>{{ formatNumber(rowData.DIFFERENCE) }}</b></td>
          </tr>
        </tbody>
      </table>
      <table class="table table-bordered custom-table">
        <tbody>
          <tr>
            <td width="50%"><b>Previously Entered Explanations:</b></td>
            <td width="50%"><b>Enter New Explanation:</b></td>
          </tr>
          <tr>
            <td width="50%">
              <textarea style="min-height:80px; width:100%" readonly name="oldExplanation" [ngModel]="rowData.EXPLANATION"></textarea>
            </td>
            <td width="50%">
              <textarea style="min-height:80px; width:100%" name="newExplanation"
                [ngModel]="newExplanation"
                (ngModelChange)="onNewExplanationChange($event)"></textarea>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
}
</div>

<!-- Footer -->
<div class="modal-footer" [hidden]="minimise">
  <button class="save-button"
          type="button"
          [disabled]="isSaveClicked"
          (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save
  </button>
  <button class="cancel-button"
          type="button"
          (click)="cancel()">Cancel</button>
</div>
